var map = {
	"./devices/MacbookPro.png": 3260,
	"./devices/Smartphone.png": 3261,
	"./devices/browser.png": 3262,
	"./devices/smartphonePixel.png": 3263,
	"./devices/smartphonePixelScreen.png": 3264
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3302;


//////////////////
// WEBPACK FOOTER
// ./src/assets \.\/devices\/[^\/]+\.(jpg|jepg|png)$
// module id = 3302
// module chunks = 0